<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  /* eslint-disable perfectionist/sort-union-types */
  cols?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  sm?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  md?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  xl?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  startLg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  startXl?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
}>(), {
  cols: 12,
})

const classes = computed(() => [
  {
    'col-span-1': props.cols === 1,
    'col-span-2': props.cols === 2,
    'col-span-3': props.cols === 3,
    'col-span-4': props.cols === 4,
    'col-span-5': props.cols === 5,
    'col-span-6': props.cols === 6,
    'col-span-7': props.cols === 7,
    'col-span-8': props.cols === 8,
    'col-span-9': props.cols === 9,
    'col-span-10': props.cols === 10,
    'col-span-11': props.cols === 11,
    'col-span-12': props.cols === 12,
  },
  {
    'sm:col-span-1': props.sm === 1,
    'sm:col-span-2': props.sm === 2,
    'sm:col-span-3': props.sm === 3,
    'sm:col-span-4': props.sm === 4,
    'sm:col-span-5': props.sm === 5,
    'sm:col-span-6': props.sm === 6,
    'sm:col-span-7': props.sm === 7,
    'sm:col-span-8': props.sm === 8,
    'sm:col-span-9': props.sm === 9,
    'sm:col-span-10': props.sm === 10,
    'sm:col-span-11': props.sm === 11,
    'sm:col-span-12': props.sm === 12,
  },
  {
    'md:col-span-1': props.md === 1,
    'md:col-span-2': props.md === 2,
    'md:col-span-3': props.md === 3,
    'md:col-span-4': props.md === 4,
    'md:col-span-5': props.md === 5,
    'md:col-span-6': props.md === 6,
    'md:col-span-7': props.md === 7,
    'md:col-span-8': props.md === 8,
    'md:col-span-9': props.md === 9,
    'md:col-span-10': props.md === 10,
    'md:col-span-11': props.md === 11,
    'md:col-span-12': props.md === 12,
  },
  {
    'lg:col-span-1': props.lg === 1,
    'lg:col-span-2': props.lg === 2,
    'lg:col-span-3': props.lg === 3,
    'lg:col-span-4': props.lg === 4,
    'lg:col-span-5': props.lg === 5,
    'lg:col-span-6': props.lg === 6,
    'lg:col-span-7': props.lg === 7,
    'lg:col-span-8': props.lg === 8,
    'lg:col-span-9': props.lg === 9,
    'lg:col-span-10': props.lg === 10,
    'lg:col-span-11': props.lg === 11,
    'lg:col-span-12': props.lg === 12,
  },
  {
    'xl:col-span-1': props.xl === 1,
    'xl:col-span-2': props.xl === 2,
    'xl:col-span-3': props.xl === 3,
    'xl:col-span-4': props.xl === 4,
    'xl:col-span-5': props.xl === 5,
    'xl:col-span-6': props.xl === 6,
    'xl:col-span-7': props.xl === 7,
    'xl:col-span-8': props.xl === 8,
    'xl:col-span-9': props.xl === 9,
    'xl:col-span-10': props.xl === 10,
    'xl:col-span-11': props.xl === 11,
    'xl:col-span-12': props.xl === 12,
  },
  {
    'lg:col-start-1': props.startLg === 1,
    'lg:col-start-2': props.startLg === 2,
    'lg:col-start-3': props.startLg === 3,
    'lg:col-start-4': props.startLg === 4,
    'lg:col-start-5': props.startLg === 5,
    'lg:col-start-6': props.startLg === 6,
    'lg:col-start-7': props.startLg === 7,
    'lg:col-start-8': props.startLg === 8,
    'lg:col-start-9': props.startLg === 9,
    'lg:col-start-10': props.startLg === 10,
    'lg:col-start-11': props.startLg === 11,
    'lg:col-start-12': props.startLg === 12,
  },
  {
    'xl:col-start-1': props.startXl === 1,
    'xl:col-start-2': props.startXl === 2,
    'xl:col-start-3': props.startXl === 3,
    'xl:col-start-4': props.startXl === 4,
    'xl:col-start-5': props.startXl === 5,
    'xl:col-start-6': props.startXl === 6,
    'xl:col-start-7': props.startXl === 7,
    'xl:col-start-8': props.startXl === 8,
    'xl:col-start-9': props.startXl === 9,
    'xl:col-start-10': props.startXl === 10,
    'xl:col-start-11': props.startXl === 11,
    'xl:col-start-12': props.startXl === 12,
  },
])
</script>
